import { render, staticRenderFns } from "./Scaling_First.vue?vue&type=template&id=5fac2627&scoped=true&lang=pug&"
import script from "./Scaling_First.vue?vue&type=script&lang=ts&"
export * from "./Scaling_First.vue?vue&type=script&lang=ts&"
import style0 from "./Scaling_First.vue?vue&type=style&index=0&id=5fac2627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac2627",
  null
  
)

export default component.exports